module.exports = __webpack_public_path__ + "static/media/YF95_3.190c0a67.jpg";